import PubSub from "underpub-js";
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

var ImageSliderFullWidth = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ImageSliderFullWidth',
	};

	$.extend(true, this.options, options);

};

ImageSliderFullWidth.prototype.init = function() {

	var self = this;

	this.autoplaySpeed = 8000;
	this.sliderAutoplayInterval = null;

	this.$imageSlider = this.options.$el.find(`.${self.options.baseClass}__imageSlider`);

	// initialize image slider
	this.$imageSlider.slick({
		arrows: false,
		fade: true,
		infinite: true,
		speed: 750,
		swipe: false,
	});

	// kick off autoplay
	this.restartAutoplay();

	// swipe events
	this.options.$el.on('swiperight', function() {
		self.restartAutoplay();
		self.previousSlide();
	});

	this.options.$el.on('swipeleft', function() {
		self.restartAutoplay();
		self.nextSlide();
	});

	this.options.$el.find(`.${self.options.baseClass}__previousSlide`).on('click', function() {
		self.restartAutoplay();
		self.previousSlide();
	});

	this.options.$el.find(`.${self.options.baseClass}__nextSlide`).on('click', function() {
		self.restartAutoplay();
		self.nextSlide();
	});

};

ImageSliderFullWidth.prototype.restartAutoplay = function() {

	var self = this;

	clearInterval(self.sliderAutoplayInterval);

	self.sliderAutoplayInterval = window.setInterval(function() {
		self.nextSlide();
	}, self.autoplaySpeed);

};

ImageSliderFullWidth.prototype.nextSlide = function() {
	this.$imageSlider.slick('slickNext');
};

ImageSliderFullWidth.prototype.previousSlide = function() {
	this.$imageSlider.slick('slickPrev');
};

export default ImageSliderFullWidth;
